// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2uwAW","approved":"Status_approved__1nhrO","rejected":"Status_rejected__1h9U2","expired":"Status_expired__33YaM","label":"Status_label__3GQNT"};